import React, { useState, useEffect } from "react" ;
import { getDataFromResponse } from "root/DataFunctions/BaseDataFns";
import {getUserPosts} from "root/DataFunctions/PostDataFns";
import ChildPost from "../Components/ChildPost";
import Loading from "../Components/Loading";
import ChildPostDetailNew from "../Components/ChildPostDetailNew";
import '../styles/Layout/postsDashboard.scss';
import useModalAddPost from "root/Modals/AddPost/useModalAddPost"
import {MessageType} from "root/DataFunctions/Constants";

const Draft = (props) => {
    const [allPosts, setAllPosts] = useState(null);
    const [renderAddPostModal, showAddPostModal] = useModalAddPost((result) =>
    {
        if (result === 'saved')
        {
            getData();
        }
    })

    const [index, setIndex] = useState(null);
    const filteredPost = allPosts ? allPosts[index] : '';

    // Loop posts array
    const checkNumber = (number) => {
        if(number > allPosts.length - 1) {
            return 0;
        }
        if (number < 0) {
            return allPosts.length - 1;
        }
        return number;
    }
    
    const onNextPost = () => {
        setIndex((index) => {
            let newIndex = index + 1;
            return checkNumber(newIndex);
        })
    }
    
    const onPrevPost = () => {
        setIndex((index) => {
            let newIndex = index - 1;
            return checkNumber(newIndex);
        })
    }

    const onSetIndexFromPost = (indx) => {
        setIndex(indx)
    }

    // Display post modal action - edit/delete mode - Steve
    const handleActionPost = (post_id, mode) => {
        showAddPostModal(mode, null, post_id, null, MessageType.MESSAGE_TYPE_LIFESTORY);
     }

    useEffect(()=>{
        getData();
    }, []);

    const getData = () => {
        getUserPosts("draft", response =>
        {
            setAllPosts(getDataFromResponse(response));
        });
    };

    return (
        <>
            <div style={{display: "flex", flexDirection: "column", flex: "1"}}>
                <div className="child_breadcrumb child_breadcrumb-main">
                    <div className="child_breadcrumb_inner">
                        <h2 className="child_breadcrumb_title">Drafts</h2>
                    </div>
                </div>

                <div className="child-post-items">
                    {allPosts 
                        && index !== null 
                        && <ChildPostDetailNew 
                                totalPost={allPosts.length} 
                                index={index} 
                                filteredPost={filteredPost} 
                                nextPost={onNextPost} 
                                prevPost={onPrevPost} 
                                setIndex={setIndex}
                                postStatus={'draft'}
                            />
                    }
                    {allPosts 
                        ? allPosts.map( (post, i) => 
                                        <ChildPost 
                                            key={post.post_id} 
                                            post={post} 
                                            setIndexFromPost={onSetIndexFromPost} 
                                            postIndex={i}
                                            pubDraft={"draft"}
                                            actionPost={handleActionPost}
                                        /> 
                                    )
                        : <Loading />
                    }
                </div>
            </div>

            {renderAddPostModal()}
        </>
    );
}

export default Draft;
